import { accountsApiRtkQuery } from '@chillibean/accounts-api-client-sdk';
import { Card, Title, Pill, NoContent } from '@chillibean/component-library/legacy';
import pluralize from 'pluralize';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import LogAndDisplayError from '../../../LogAndDisplayError/LogAndDisplayError';
import { selectInternalResult } from '../redux/internal.slice';

function ProtocolList() {
  const { accountId } = useSelector(selectInternalResult);
  const { useGetStudyProtocolsQuery } = accountsApiRtkQuery;
  const {
    data: protocols,
    error: protocolsError,
    isLoading: isProtocolsLoading,
  } = useGetStudyProtocolsQuery({ accountId: accountId }, { skip: !accountId });
  const history = useHistory();

  const onSelectProtocol = (protocolId) => history.push(`/site/${protocolId}`);

  const nonEmptyProtocols = protocols?.filter((protocol) => protocol.numberOfStudyProcedures > 0);

  const ProtocolCards = () => {
    return nonEmptyProtocols.map((protocol) => (
      <Card
        headingIcon="roundAddLocation"
        heading={protocol.name}
        subheading={`${protocol.id}`}
        key={`${protocol.id}`}
        active
        clickHandler={() => onSelectProtocol(protocol.id)}
      />
    ));
  };

  if (protocolsError) {
    if (protocolsError.status === 403) {
      return (
        <>
          <Title heading="Sites Reporting" subheading="" />
          <div className="header-wrapper-protocol-report-no-content">
            <NoContent>Sites are not currently enabled on this trial</NoContent>
          </div>
        </>
      );
    }

    return <LogAndDisplayError error={protocolsError} />;
  }

  const renderProtocolCards = useMemo(() => {
    if (isProtocolsLoading || !protocols) {
      return [...Array(4).keys()].map((key) => <Card key={key} loading />);
    }

    if (nonEmptyProtocols?.length === 0) {
      return <EmptyContainer>No trial configurations to show yet</EmptyContainer>;
    }

    return <ProtocolCards />;
  }, [isProtocolsLoading, nonEmptyProtocols]);

  return (
    <>
      <div className="header-wrapper-protocolReportList">
        <Title heading="Sites Reporting" subheading="" loading={isProtocolsLoading} />
        <Pill
          dataCount={isProtocolsLoading || !nonEmptyProtocols ? '' : `${nonEmptyProtocols?.length}`}
          dataContext={pluralize('Trial Configuration', nonEmptyProtocols?.length)}
          loading={isProtocolsLoading}
        />
      </div>
      <div className="protocols-overflow">
        {renderProtocolCards}
        <div className="spacing" />
      </div>
    </>
  );
}

const EmptyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f4f7fb;
  width: 100%;
  height: 100%;
  font-weight: 400;
  font-size: 13px;
`;

export default ProtocolList;
